/* Check for mobile user agent or small screen size (safety net)
  if (/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || window.matchMedia("(max-width: 768px)").matches) {
    let lastScrollTop = 0;

    window.onscroll = function () {
      var filterDiv = document.querySelector('.mobile-filter-wrap');
      if (!filterDiv) return;

      var scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (scrollTop > lastScrollTop) {
        filterDiv.style.position = 'fixed';
        filterDiv.style.top = '60px';
        filterDiv.style.padding = '10px 5px';
        filterDiv.style.width = '100%';
        filterDiv.style.display = 'flex';
      } else {
        filterDiv.style.display = 'none';
      }

      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    };
  }
    */
  
  if (/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || window.matchMedia("(max-width: 768px)").matches) {
  let lastScrollTop = 0;

  // Wait until DOM is ready
  document.addEventListener("DOMContentLoaded", function () {
    const filterDiv = document.querySelector('.mobile-filter-wrap');
    if (!filterDiv) return;

    // Save original styles
    const originalStyles = {
      position: filterDiv.style.position || '',
      top: filterDiv.style.top || '',
      padding: filterDiv.style.padding || '',
      width: filterDiv.style.width || '',
      display: filterDiv.style.display || ''
    };

    window.addEventListener('scroll', function () {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (scrollTop === 0) {
        // Reset to initial styles when back at the top
        filterDiv.style.position = originalStyles.position;
        filterDiv.style.top = originalStyles.top;
        filterDiv.style.padding = originalStyles.padding;
        filterDiv.style.width = originalStyles.width;
        filterDiv.style.display = originalStyles.display;
      } else {
        // Scrolling down or up – keep it fixed and visible
        filterDiv.style.position = 'fixed';
        filterDiv.style.top = '56px';
        filterDiv.style.padding = '10px 5px';
        filterDiv.style.width = '100%';
        filterDiv.style.display = 'flex';
      }

      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    });
  });
}
